import { Icon } from "@blueprintjs/core";

import { pluralize } from "@/components/helpers/string-utils";
import { DateTimeDisplay } from "@/components/pieces/DateTimeDisplay";
import { ComponentTypeEnum, GetProgramCoachingSessionsQuery } from "@/graphql";
import { LeadComponent } from "@/types/programs";
import { NonNullableArrayItem } from "@/utils/types";

type Session = NonNullableArrayItem<
  GetProgramCoachingSessionsQuery["programCoachingSessions"]
>;

type LeadChild = NonNullableArrayItem<LeadComponent["childComponents"]>;

interface OneOneMeetingDateTimeDisplayProps {
  meeting: Session | LeadChild;
}

export function OneOneMeetingDateTimeDisplay({
  meeting,
}: OneOneMeetingDateTimeDisplayProps) {
  const isIntroSession =
    meeting?.type === ComponentTypeEnum.OneOneCoachingIntro;
  return (
    <div className="flex xs:gap-2 md:gap-0 xs:items-start xs:flex-col md:flex-row md:items-center text-sm">
      {isIntroSession && (
        <div>
          <div className="inline-block">
            {pluralize({
              amount: meeting.introSessionCount || 0,
              singular: "session",
              plural: "sessions",
            })}
          </div>
          <div className="xs:hidden md:inline-block mx-1.5">・</div>
        </div>
      )}
      <div className="flex items-center">
        <Icon icon="calendar" style={{ marginRight: 5 }} />
        <DateTimeDisplay time={meeting.targetStartDate} formatString="MMM d" />
        <div>&nbsp;-&nbsp;</div>
        <DateTimeDisplay time={meeting?.targetEndDate} formatString="MMM d" />
      </div>

      <div className="xs:hidden md:inline-block mx-1.5">・</div>
      <div className="inline-block">
        {meeting?.type === ComponentTypeEnum.OneOneCoachingIntro
          ? "Intro Session"
          : meeting?.product?.name}
      </div>
    </div>
  );
}
